import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsOcamlComponent } from './simple-icons-ocaml.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsOcamlComponent ],
    exports:      [ SimpleIconsOcamlComponent ],
    bootstrap:    []
})
export class SimpleIconsOcamlModule {}
